import React, { useState, useRef, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { getConfig } from '@edx/frontend-platform';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { AppContext } from '@edx/frontend-platform/react';


export const ExpandedHeader = () => {
  const [isActive, setIsActive] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);
  const { authenticatedUser } = useContext(AppContext);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        event.target !== document.getElementById('myImg')
      ) {
        setIsDropdownVisible(false);
      }
    };

    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  const toggleDropdown = (event) => {
    event.stopPropagation();
    setIsDropdownVisible(prev => !prev);
  };

  const toggleActive = () => {
    setIsActive(prev => !prev);
  };


  return (
    <header className={`site-header-desktop ${isActive ? 'active' : ''}`}>
        <div className="header-content">
          <h1 className="header-logo">
              <a href={`${getConfig().LMS_BASE_URL}/dashboard`}>
                  <h1 className="unu-logo-text">United Nations University</h1>
                  <p className="unu-logo-tag-text">Institute for Water, Environment and Health</p>
              </a>
          </h1>
          <div className="nav-item hidden-mobile">
              <div ref={dropdownRef} className="nav-item-dropdown" tabIndex="-1">
                  <a className="menu-title" onClick={toggleDropdown}>
                      <img className="user-image-frame" id="myImg" src="https://wlc.unu.edu/static/UNU/images/drop.png" alt="" />
                  </a>
              </div>
              <div ref={dropdownRef} className={`dropdown-user-menu ${isDropdownVisible ? '' : 'hidden'}`} role="menu" id="user-menu" tabIndex="-1">
                  <div className="mobile-nav-item dropdown-item dropdown-nav-item"><a href={`${getConfig().LMS_BASE_URL}/dashboard`} role="menuitem">Dashboard</a></div>
                  <div className="mobile-nav-item dropdown-item dropdown-nav-item"><a href={`${getConfig().ACCOUNT_PROFILE_URL}/u/${authenticatedUser.username}`} role="menuitem">Profile</a></div>
                  <div className="mobile-nav-item dropdown-item dropdown-nav-item"><a href={`${getConfig().ACCOUNT_SETTINGS_URL}`} role="menuitem">Account</a></div>
                  <div className="mobile-nav-item dropdown-item dropdown-nav-item"><a href={`${getConfig().LMS_BASE_URL}/logout`} role="menuitem">Sign Out</a></div>
              </div>
          </div>
          <div className="hamburger-menu" onClick={toggleActive}>
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
            </div>
            
      </div>
      <div className="mobile-menu" aria-label="More" options="" role="menu" id="mobile-menu">
            <div className="mobile-nav-item hidden-mobile nav-item mobile-nav-link">
              <a className="help-link" href={`${getConfig().LMS_BASE_URL}/help`} target="_blank" role="menuitem">Help</a>
            </div>
            <div className="mobile-nav-item dropdown-item dropdown-nav-item mobile-nav-link">
                <a href={`${getConfig().LMS_BASE_URL}/dashboard`} role="menuitem">Dashboard</a>
            </div>
            <div className="mobile-nav-item dropdown-item dropdown-nav-item mobile-nav-link">
                <a href={`${getConfig().ACCOUNT_PROFILE_URL}/u/${authenticatedUser.username}`} role="menuitem">Profile</a>
            </div>
            <div className="mobile-nav-item dropdown-item dropdown-nav-item mobile-nav-link">
                <a href={`${getConfig().ACCOUNT_SETTINGS_URL}`} role="menuitem">Account</a>
            </div>
            <div className="mobile-nav-item dropdown-item dropdown-nav-item mobile-nav-link">
                <a href={`${getConfig().LMS_BASE_URL}/logout`} role="menuitem">Sign Out</a>
            </div>
            <div className="mobile-nav-item hidden-mobile nav-item nav-tab mobile-nav-link">
                <a className="tab-nav-link" href={`${getConfig().LMS_BASE_URL}/dashboard`} role="menuitem">My Courses</a>
            </div>
            <div className="mobile-nav-item hidden-mobile nav-item nav-tab mobile-nav-link">
                <a href={`${getConfig().LMS_BASE_URL}/courses`} role="menuitem">Explore New Courses</a>
            </div>
      </div>
    </header>
  );
};

ExpandedHeader.propTypes = {};

export default ExpandedHeader;
